import React, { Component } from "react";
import { connect } from "react-redux";

import FilterComponent from "./FilterComponent";

import {
  fetchBlogCategories,
  fetchBlogTypes,
  fetchBlogThemes,
  fetchMediaCategories
} from "Thunks";

class Filter extends Component {
  componentDidMount() {
    const {
      type,
      fetchBlogCategories,
      fetchBlogTypes,
      fetchBlogThemes,
      fetchMediaCategories,
      categories,
      types,
      themes
    } = this.props;
    switch (type) {
      case "BLOG":
        if (!categories.fetched) {
          fetchBlogCategories();
        }
        if (!types.fetched) {
          fetchBlogTypes();
        }
        if (!themes.fetched) {
          fetchBlogThemes();
        }
        break;
      case "MEDIA":
        if (!categories.fetched) {
          fetchMediaCategories({ limit: 100 });
        }
        break;
    }
  }

  render() {
    return <FilterComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = (state, ownProps) => ({
  categories: state.filters[ownProps.type].categories,
  types: state.filters[ownProps.type].types,
  themes: state.filters[ownProps.type].themes,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  fetchBlogCategories: () => dispatch(fetchBlogCategories()),
  fetchBlogTypes: () => dispatch(fetchBlogTypes()),
  fetchBlogThemes: () => dispatch(fetchBlogThemes()),
  fetchMediaCategories: params => dispatch(fetchMediaCategories(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Filter/index.js